import { Association } from 'models/Association';

export default (associations: Association[]) =>
  associations?.map((el) => ({
    label: `${el?.acronym ? `${el?.acronym} - ` : ''}${el?.name}`,
    value: el._id,
  }));
